// extracted by mini-css-extract-plugin
export default {"container":"stats_container__xeI7J","calender":"stats_calender__eUd8D"};